import { Button } from "@crialume/ui";
import { useSyncExternalStore } from "react";
import { analyticsEnabled, readConsent, setConsent, subscribeConsent } from "./analytics";
import "./consent-banner.css";

/** Pergunta uma vez se a pessoa aceita o Google Analytics. Sem resposta, nada é medido. */
export function ConsentBanner() {
  const consent = useSyncExternalStore(subscribeConsent, readConsent, () => null);
  if (!analyticsEnabled() || consent !== null) return null;
  return (
    <section className="consent-banner" role="region" aria-label="Cookies de medição">
      <p>
        Usamos cookies do Google Analytics para entender como o site é usado e melhorar a sua
        experiência. Você pode recusar sem perder nada.
      </p>
      <div>
        <Button variant="ghost" onClick={() => setConsent("denied")}>
          Recusar
        </Button>
        <Button onClick={() => setConsent("granted")}>Aceitar</Button>
      </div>
    </section>
  );
}
